import { FC, useEffect, useState } from "react";
import Modal from "react-modal";
import "./index.css";
import { cepNoMask, cepToMask } from "../../functions/mask";
import useAuth from "../../hooks/useAuth";
import { usePluginspace } from "../../hooks/usePluginspace";
import { useNavigate, useParams } from "react-router-dom";
import InputMask from "react-input-mask";
import { address } from "../../pages/Perfil/addresses/addressesIndex";
import api from "../../services/api";

import "./index.css";
import Swal from "sweetalert2";

type props = {
  isOpen: boolean;
  setIsOpen: (value: boolean) => void;
  addresses: address[];
  setAddress: (value: address) => void;
  verifyAddress: (value: any) => void;
  setCreateAddressOpen?: (value: boolean) => void;
  setCep?: (value: string) => void;
  setEditAddressOpen?: (value: boolean) => void;
  setEditAddressData?: (value: address) => void;
  setAllAddresses?: (value: address[]) => void;
  setAllAddress?: (value: any) => void;
};

const ModalSelectAddress: FC<props> = ({
  isOpen,
  setIsOpen,
  addresses,
  setAddress,
  verifyAddress,
  setCreateAddressOpen,
  setCep,
  setEditAddressOpen,
  setEditAddressData,
  setAllAddresses,
  setAllAddress,
}) => {
  const [selectAddressOpen, setSelectAddressOpen] = useState(false);
  const [localAddresses, setLocalAddresses] = useState<address[]>(addresses);

  useEffect(() => {
    setLocalAddresses(addresses);
  }, [addresses]);

  // const selectFirstAvailableAddress = (addressList: address[]) => {
  //   const filteredAddresses = addressList.filter(
  //     (address: address) => address.extra && address.extra !== ""
  //   );

  //   if (filteredAddresses.length > 0) {
  //     const firstAddress = filteredAddresses[0];
  //     setAddress(firstAddress);
  //     setCep && setCep(firstAddress.zipCode || "");
  //     verifyAddress(firstAddress.zipCode);
  //   }
  // };

  const selectAddress = (value: address) => {
    setAddress(value);
    setCep && setCep(value.zipCode || "");
    setIsOpen(false);
    verifyAddress(value.zipCode);
  };

  const { getToken } = usePluginspace();

  return (
    <Modal
      isOpen={isOpen}
      onRequestClose={() => setIsOpen(false)}
      className="modal-select"
      contentLabel="Selecionar endereço para entrega"
      overlayClassName="overlay-modal"
      ariaHideApp={false}
    >
      <div className="modal-select-content">
        <div className="modal-select-body">
          <div
            className="modal-select-body-header"
            style={{ paddingBottom: "0.4rem" }}
          >
            <h4>Selecionar endereço</h4>

            <svg
              onClick={() => setIsOpen(false)}
              width="17"
              height="17"
              viewBox="0 0 17 17"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M0.978551 2.97126L6.957 8.94971L0.978551 14.9282L2.97137 16.921L8.94981 10.9425L14.9283 16.921L16.9211 14.9282L10.9426 8.94971L16.9211 2.97126L14.9283 0.978446L8.94981 6.95689L2.97137 0.978446L0.978551 2.97126Z"
                fill="#636363"
              />
            </svg>
          </div>

          <div className="modal-select-body-addresses">
            {localAddresses
              .filter(
                (address: address) => address.extra && address.extra != ""
              )
              .map((address: address) => (
                <div className="address" key={address.id}>
                  <div className="address-Option">
                    <div
                      onClick={() => selectAddress(address)}
                      style={{
                        display: "flex",
                        flexDirection: "column",
                        width: "100%",
                      }}
                    >
                      <span
                        style={{ fontWeight: "bold", paddingBottom: "6px" }}
                      >
                        {address.street}, {address.number}
                      </span>
                      <span style={{ fontSize: "0.775rem" }}>
                        {address.district} - CEP {cepToMask(address.zipCode)}
                      </span>
                      <span style={{ fontSize: "0.775rem" }}>
                        {address.city} - {address.state}
                      </span>
                      <span style={{ fontSize: "0.775rem" }}>
                        {`${address.extra || ""}${
                          address.extra && address.complement ? " - " : ""
                        }${address.complement || ""}`}
                      </span>
                    </div>
                    <div
                      style={{
                        borderTop: "1px solid #e0e0e0",
                        textAlign: "left",
                        paddingBottom: "0.4rem",
                        marginLeft: "-8px",
                        width: "calc(100% + 16px)",
                        marginTop: "8px",
                      }}
                    ></div>
                    <div
                      className="address_edit"
                      style={{
                        paddingBottom: "0.4rem",
                        paddingTop: "4px",
                        display: "flex",
                        alignItems: "center",
                        gap: "16px",
                      }}
                    >
                      <span
                        onClick={() => {
                          setIsOpen(false);
                          setEditAddressData && setEditAddressData(address);
                          setEditAddressOpen && setEditAddressOpen(true);
                        }}
                        style={{
                          cursor: "pointer",
                          display: "flex",
                          alignItems: "center",
                          gap: "4px",
                          color: "#3c9ee5",
                        }}
                      >
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          width="14"
                          height="14"
                          viewBox="0 0 24 24"
                          fill="none"
                          stroke="#3c9ee5"
                          strokeWidth="2"
                          strokeLinecap="round"
                          strokeLinejoin="round"
                        >
                          <path d="M18 2L22 6L7 21H3V17L18 2Z" />
                        </svg>
                        Editar
                      </span>
                      {addresses.length > 1 && (
                        <span
                          onClick={async () => {
                            const result = await Swal.fire({
                              icon: "warning",
                              title: `Tem certeza que deseja excluir o endereço ${address.extra}?`,
                              text: "Essa ação não poderá ser desfeita.",
                              showCancelButton: true,
                              confirmButtonText: "Sim, excluir",
                              cancelButtonText: "Cancelar",
                              confirmButtonColor: "#eb5353",
                              cancelButtonColor: "#cfcfcf",
                            });

                            if (result.isConfirmed) {
                              try {
                                const token = await getToken();
                                const response = await api.delete(
                                  `/api/customer/address/${address.customerId}/${address.id}`,
                                  {
                                    headers: {
                                      Authorization: `Bearer ${token}`,
                                    },
                                  }
                                );

                                if (response.data.success) {
                                  const updatedList = localAddresses.filter(
                                    (item) => item.id !== address.id
                                  );
                                  setLocalAddresses(updatedList);
                                  setAllAddress && setAllAddress(updatedList);
                                  setAllAddresses &&
                                    setAllAddresses(updatedList);

                                  const filteredAddresses = updatedList.filter(
                                    (addr: address) =>
                                      addr.extra && addr.extra !== ""
                                  );
                                  if (filteredAddresses.length > 0) {
                                    const firstAddress = filteredAddresses[0];
                                    setAddress(firstAddress);
                                    setCep &&
                                      setCep(firstAddress.zipCode || "");
                                    verifyAddress(firstAddress.zipCode);
                                  }
                                } else {
                                  Swal.fire({
                                    icon: "error",
                                    title: "Erro!",
                                    text: "Não foi possível excluir o endereço.",
                                  });
                                }
                              } catch (err) {
                                console.error(err);
                                Swal.fire({
                                  icon: "error",
                                  title: "Erro!",
                                  text: "Ocorreu um erro ao excluir o endereço.",
                                });
                              }
                            }
                          }}
                          style={{
                            cursor: "pointer",
                            display: "flex",
                            alignItems: "center",
                            gap: "4px",
                            color: "#eb5353",
                          }}
                        >
                          <svg
                            xmlns="http://www.w3.org/2000/svg"
                            width="14"
                            height="14"
                            viewBox="0 0 24 24"
                            fill="none"
                            stroke="#eb5353"
                            strokeWidth="2"
                            strokeLinecap="round"
                            strokeLinejoin="round"
                          >
                            <polyline points="3 6 5 6 21 6" />
                            <path d="M19 6L18.4 19.4a2 2 0 0 1-2 1.6H7.6a2 2 0 0 1-2-1.6L5 6m3 0V4a1 1 0 0 1 1-1h6a1 1 0 0 1 1 1v2" />
                          </svg>
                          Excluir
                        </span>
                      )}
                    </div>
                  </div>
                </div>
              ))}
            <div
              onClick={() => {
                setIsOpen(false);
                setCreateAddressOpen && setCreateAddressOpen(true);
              }}
            >
              <div className="address">
                <div className="address-new">
                  <span className="icon">
                    <svg width="14" height="14" viewBox="0 0 24 24" fill="none">
                      <path
                        d="M12 5v14M5 12h14"
                        stroke="#3c9ee5"
                        strokeWidth="2"
                        stroke-linecap="round"
                      />
                    </svg>
                  </span>
                  <span className="label">Adicionar endereço</span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </Modal>
  );
};

export { ModalSelectAddress };
